(function () {
  var overlay = document.querySelector('[data-pm-atc-overlay]');
  if (!overlay) return;

  var html = document.documentElement;
  var body = document.body;
  var activeBanner = null;
  var bannerObserver = null;
  var mountTimer = null;

  function isLiveBanner(el) {
    return (
      el &&
      el.nodeType === 1 &&
      el.matches('[data-atc-banner]') &&
      !el.closest('[data-templates]')
    );
  }

  function shouldShowOverlay(banner) {
    if (!isLiveBanner(banner)) return false;

    var animation = banner.getAttribute('data-animation') || '';
    if (animation === 'open=>closed') return false;

    return banner.getAttribute('data-animation-state') === 'open';
  }

  function overlayIsBeforeBanner(banner) {
    return (
      banner &&
      banner.parentNode &&
      overlay.parentNode === banner.parentNode &&
      overlay.nextElementSibling === banner
    );
  }

  function mountOverlayInHeader(banner) {
    if (!banner || !banner.parentNode) return;
    if (overlayIsBeforeBanner(banner)) return;
    banner.parentNode.insertBefore(overlay, banner);
  }

  function resetOverlayHost() {
    if (overlay.parentNode !== body) {
      body.appendChild(overlay);
    }
  }

  function clearMountTimer() {
    if (mountTimer) {
      clearTimeout(mountTimer);
      mountTimer = null;
    }
  }

  function scheduleOverlayMount(banner) {
    clearMountTimer();
    mountTimer = setTimeout(function () {
      mountTimer = null;
      if (!activeBanner || activeBanner !== banner || !shouldShowOverlay(banner)) return;
      mountOverlayInHeader(banner);
    }, 0);
  }

  function setOverlayVisible(visible) {
    if (visible) {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      overlay.classList.add('pm-atc-overlay--visible');
      html.classList.add('pm-atc-open');
      body.classList.add('pm-atc-open');
      if (activeBanner) scheduleOverlayMount(activeBanner);
      return;
    }

    clearMountTimer();
    overlay.classList.remove('pm-atc-overlay--visible');
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    html.classList.remove('pm-atc-open');
    body.classList.remove('pm-atc-open');
    resetOverlayHost();
  }

  function syncOverlay() {
    if (activeBanner && !document.body.contains(activeBanner)) {
      activeBanner = null;
      if (bannerObserver) {
        bannerObserver.disconnect();
        bannerObserver = null;
      }
    }

    setOverlayVisible(activeBanner ? shouldShowOverlay(activeBanner) : false);
  }

  function watchBanner(banner) {
    if (!isLiveBanner(banner)) return;

    activeBanner = banner;

    if (bannerObserver) bannerObserver.disconnect();

    bannerObserver = new MutationObserver(syncOverlay);
    bannerObserver.observe(banner, {
      attributes: true,
      attributeFilter: ['data-animation-state', 'data-animation'],
    });

    syncOverlay();
  }

  function findLiveBanner(node) {
    if (!node || node.nodeType !== 1) return null;
    if (isLiveBanner(node)) return node;

    var banners = node.querySelectorAll ? node.querySelectorAll('[data-atc-banner]') : [];
    var i;

    for (i = 0; i < banners.length; i++) {
      if (isLiveBanner(banners[i])) return banners[i];
    }

    return null;
  }

  var domObserver = new MutationObserver(function (mutations) {
    var i;
    var j;
    var mutation;
    var banner;

    for (i = 0; i < mutations.length; i++) {
      mutation = mutations[i];
      if (mutation.type !== 'childList') continue;

      for (j = 0; j < mutation.addedNodes.length; j++) {
        banner = findLiveBanner(mutation.addedNodes[j]);
        if (banner) watchBanner(banner);
      }
    }

    if (activeBanner && !document.body.contains(activeBanner)) {
      syncOverlay();
    }
  });

  domObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
